function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import assign from 'lodash/assign';
import find from 'lodash/find';
import filter from 'lodash/filter';
import pick from 'lodash/pick';
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import { SET_NEW_CONFIGURATION_VERSION } from 'modules/App/actionTypes';
import * as actionTypes from './actionTypes';
import * as constants from './constants';
const initialState = {
    information: null,
    informationTemplate: null,
    consentsTemplate: [],
    isNoMandatoryConsent: false,
    isNoMandatoryInformation: false,
    fetching: [],
    sending: [],
    errors: []
};
// eslint-disable-next-line default-param-last
export default function reducer(state = _object_spread({}, initialState), action) {
    switch(action.type){
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CHECK_INFORMATION:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.CHECK_INFORMATION),
                    errors: unregisterAction(state.errors, actionTypes.CHECK_INFORMATION)
                });
            }
        case actionTypes.CHECK_INFORMATION_SUCCESS:
            {
                const { information, informationTemplate, consentsTemplate, isNoMandatoryConsent, isNoMandatoryInformation } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    information: _object_spread({}, state.information, information),
                    informationTemplate,
                    consentsTemplate,
                    isNoMandatoryConsent,
                    isNoMandatoryInformation,
                    fetching: unregisterAction(state.fetching, actionTypes.CHECK_INFORMATION)
                });
            }
        case actionTypes.CHECK_INFORMATION_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.CHECK_INFORMATION),
                    errors: registerAction(state.errors, actionTypes.CHECK_INFORMATION)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_BASIC_INFORMATION_UPDATE:
            {
                const { informationUpdate } = action.payload;
                const basicInformationUpdate = pick(informationUpdate, constants.BASIC_INFORMATION);
                const information = assign(basicInformationUpdate, state.information);
                return _object_spread_props(_object_spread({}, state), {
                    information
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_CONSENTS_TEMPLATE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_CONSENTS_TEMPLATE),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_CONSENTS_TEMPLATE)
                });
            }
        case actionTypes.FETCH_CONSENTS_TEMPLATE_SUCCESS:
            {
                const { consentsTemplate } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    consentsTemplate,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CONSENTS_TEMPLATE)
                });
            }
        case actionTypes.FETCH_CONSENTS_TEMPLATE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CONSENTS_TEMPLATE),
                    errors: registerAction(state.errors, actionTypes.FETCH_CONSENTS_TEMPLATE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SEND_INFORMATION:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.SEND_INFORMATION),
                    errors: unregisterAction(state.errors, actionTypes.SEND_INFORMATION)
                });
            }
        case actionTypes.SEND_INFORMATION_SUCCESS:
            {
                const { information, informationTemplate, consentsTemplate, isNoMandatoryConsent, isNoMandatoryInformation } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    information,
                    informationTemplate,
                    consentsTemplate,
                    isNoMandatoryConsent,
                    isNoMandatoryInformation,
                    sending: unregisterAction(state.sending, actionTypes.SEND_INFORMATION)
                });
            }
        case actionTypes.SEND_INFORMATION_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SEND_INFORMATION),
                    errors: registerAction(state.errors, actionTypes.SEND_INFORMATION)
                });
            }
        // BackOffice UPDATE -----------------------------------------------------------------------------------------------
        case SET_NEW_CONFIGURATION_VERSION:
            {
                const { consentsTemplateByCountryCode } = action.payload;
                const { countryCode } = find(state.consentsTemplate || [], (consentsTemplate)=>consentsTemplate.countryCode) || {};
                if (!countryCode) {
                    return _object_spread({}, state);
                }
                const consentsTemplate = filter(consentsTemplateByCountryCode, (consentTemplate)=>consentTemplate.countryCode === countryCode || consentTemplate.countryCode === undefined);
                if (!consentsTemplate) {
                    return _object_spread({}, state);
                }
                return _object_spread_props(_object_spread({}, state), {
                    consentsTemplate
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_PROFILE_AVATAR_SUCCESS:
            {
                const { avatar } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    information: _object_spread_props(_object_spread({}, state.information), {
                        base64Avatar: avatar
                    })
                });
            }
        default:
            {
                return state;
            }
    }
}
